<div class="overflow-hidden pt-1.5 pl-3 transition-all duration-500 ease-in-out"
  [style.max-height]="submenu.expanded && (menuService.showSideBar || menuService.showMobileMenu) ? '1000px' : '0px'"
  [style.opacity]="submenu.expanded && (menuService.showSideBar || menuService.showMobileMenu) ? '1' : '0'">
  <ul class="flex flex-col relative pl-3 space-y-0.5">
    <!-- Ligne de connexion verticale décorative -->
    <div
      class="absolute left-0 top-2 bottom-2 w-[2px] bg-gradient-to-b from-brand-primary/40 via-brand-primary/15 to-transparent rounded-full">
    </div>

    <li *ngFor="let sub of submenu.children; let isLast = last" (click)="toggleMobileMenu()" class="relative">
      <div *ngIf="!sub.routePermission || authService.hasPermission(sub.routePermission)"
        class="group relative flex rounded-lg transition-all duration-300 hover:bg-white/[0.05]"
        (click)="toggleMenu(sub)">

        <!-- Point de connexion décoratif -->
        <div
          class="absolute -left-3 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-slate-600 group-hover:bg-brand-primary group-hover:scale-125 transition-all duration-300">
        </div>

        <!-- Condition -->
        <ng-container [ngTemplateOutlet]="sub.children ? childMenu : parentMenu"
          [ngTemplateOutletContext]="{ sub: sub }">
        </ng-container>

        <!-- Parent Menu -->
        <ng-template #parentMenu let-sub="sub">
          <a [routerLink]="sub.route" routerLinkActive="active-submenu" [routerLinkActiveOptions]="{ exact: true }"
            class="w-full px-3 py-2.5 text-xs font-medium flex items-center gap-2.5 rounded-lg transition-all duration-300 relative overflow-hidden group/link">

            <!-- Icône -->
            <div
              class="relative z-10 pointer-events-none p-1.5 rounded-lg transition-all duration-300
                        text-slate-500 bg-white/[0.04]
                        group-hover/link:bg-brand-primary/15 group-hover/link:text-brand-primary
                        group-[.active-submenu]:bg-brand-primary group-[.active-submenu]:text-white">
              <i attr.data-feather="{{ sub.icon }}" class="h-3.5 w-3.5"></i>
            </div>

            <!-- Label -->
            <span class="relative z-10 text-slate-400
                         group-hover/link:text-slate-100
                         group-[.active-submenu]:text-brand-primary group-[.active-submenu]:font-semibold
                         transition-all duration-300">
              {{ sub.label }}
            </span>

            <!-- Badge déplacé depuis l'item parent quand le sous-menu est ouvert -->
            @if (sub.label == "Dépot de fonds" && deposits != 0){
            <span
              class="relative ml-auto z-10 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold">
              {{ deposits }}
            </span>
            }
            @if (sub.label == "Commandes" && pendingEcommerceOrders > 0){
            <span
              class="relative ml-auto z-10 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold">
              {{ pendingEcommerceOrders }}
            </span>
            }

            <!-- Indicateur visuel pour item actif -->
            <div
              class="absolute right-0 top-1/2 -translate-y-1/2 w-1 h-0 bg-gradient-to-b from-brand-primary to-brand-primary/60 rounded-l-full group-[.active-submenu]:h-1/2 transition-all duration-300">
            </div>
          </a>
        </ng-template>

        <!-- Child Menu (pour sous-sous-menus) -->
        <ng-template #childMenu let-sub="sub">
          <div class="inline-block w-full cursor-pointer px-3 py-2.5 text-xs font-medium rounded-lg transition-all duration-300
                      text-slate-400
                      hover:bg-white/[0.05]
                      hover:text-brand-primary
                      relative overflow-hidden group/child">
            <div class="relative z-10 flex items-center gap-2">
              <div
                class="w-1.5 h-1.5 rounded-full bg-slate-600 group-hover/child:bg-brand-primary transition-colors duration-300">
              </div>
              {{ sub.label }}

              <!-- Icône chevron pour indiquer un sous-menu -->
              <i data-feather="chevron-right"
                class="h-3 w-3 ml-auto text-slate-500 group-hover/child:text-brand-primary transition-colors duration-300"></i>
            </div>
          </div>
        </ng-template>
      </div>

      <!-- Animation de ligne pour le dernier élément -->
      @if (!isLast) {
      <div class="absolute left-0 top-full w-[2px] h-2 bg-gradient-to-b from-brand-primary/20 to-transparent"></div>
      }
    </li>
  </ul>
</div>
